import { render, staticRenderFns } from "./inputindex.vue?vue&type=template&id=1c37a828&scoped=true"
import script from "./inputindex.vue?vue&type=script&lang=js"
export * from "./inputindex.vue?vue&type=script&lang=js"
import style0 from "./inputindex.vue?vue&type=style&index=0&id=1c37a828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c37a828",
  null
  
)

export default component.exports